import { EventEmitter } from "events"
import dispatcher from "../dispatcher"

class ExceptionFilterStore extends EventEmitter {
  refreshExceptionFilter: boolean = false
  refreshPage: boolean = false
  constructor() {
    super()
    this.setMaxListeners(0)
  }

  setRefreshExceptionFilter(data: boolean) {
    this.refreshExceptionFilter = data
    this.emit("refresh_exception_filter")
  }

  getRefreshExceptionFilter(): boolean {
    return this.refreshExceptionFilter
  }

  setRefreshPage(data: boolean) {
    this.refreshPage = data
    this.emit("refresh_page")
  }

  getRefreshPage(): boolean {
    return this.refreshPage
  }
  
  handleActions(action) {
    switch (action.type) {
      case "UPDATE_REFRESH_EXCEPTION_FILTER": {
        this.setRefreshExceptionFilter(action.data)
        break
      }
      case "UPDATE_REFRESH_PAGE": {
        this.setRefreshPage(action.data)
        break
      }
    }
  }
}

const exceptionFilterStore = new ExceptionFilterStore()
dispatcher.register(exceptionFilterStore.handleActions.bind(exceptionFilterStore))

export default exceptionFilterStore